<template>
  <div>
    <v-data-table
      v-model="selected"
      :show-select="false && totaleScontrini > 0"
      item-key="rigaCodice"
      :headers="headers"
      :items="scontriniSorted"
      :options.sync="options"
      :server-items-length="totaleScontrini"
      :loading="loading"
      class="elevation-1"
      @click:row="clickRow"
      @dblclick:row="dblclickRow"
      :disable-sort="true"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 50, 100]
      }"
    >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Elenco scontrini con prodotti detraibili</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn v-if="generazioneVisibile && simulazioneVisibile" color="warning" class="mb-2 mr-5" :disabled="generaDisabled" @click="onSimulaGenerazione" title="Esegue la generazione del file ma non marca gli scontrini come Trasferiti">Simula XML Spesa sanitaria</v-btn>
        <v-btn v-if="generazioneVisibile" color="primary" class="mb-2 mr-5" :disabled="generaDisabled" @click="onGeneraXML">Genera XML Spesa sanitaria</v-btn>
        <v-btn v-if="invioVisibile && simulazioneVisibile" color="error" class="mb-2 mr-5" :disabled="generaDisabled" @click="onInviaSimulazione">Simula invio XML Spesa sanitaria</v-btn>
        <v-btn v-if="invioVisibile" color="success" class="mb-2" :disabled="generaDisabled" @click="onInviaGenerazione">Invio XML Spesa sanitaria</v-btn>
        <dialog-errore :show="dialogErrore" :title="erroreScontrino || 'Errore creazione file xml'" />
        <dialog-conferma
          :show="dialogConferma"
          :title="titoloConferma"
          :message="messaggioConferma"
          @dialog-confirm="onConferma"
          @dialog-cancel="dialogConferma=false"
        />
      </v-toolbar>
      <risposta-invio
        :showPanel="showPanelXml"
        :trasmissione="esitoTrasmissione"
        :dettaglio="dettaglioErrori"
        :esito="esitoInvio"
        :ricevuta="ricevutaPdf"
        @invio="onEsitoInvio"
        @dettaglio="onDettaglioErrori"
        @ricevuta="onRicevutaPdf"
      />
      <v-alert v-if="xmlErrors.length > 0" border="left" colored-border color="red" elevation="2" dismisseble type="error">
        <h3 class="red--text mb-3">Errore validazione XML. Verificare e ripetere il tentativo di invio</h3>
        <p v-for="(er, idx) in xmlErrors" :key="idx">Linea: {{ er.line }} - {{ er.message }}</p>
      </v-alert>
      <v-alert v-if="filtri && filtri.soloInErrore && scontrini.length > 0" elevation="2" type="warning">Attenzione! Sono visualizzate le spese che hanno generato errore nell'invio. Devono essere corrette e ritrasmesse!</v-alert>
      <filtri @ricerca="onRicerca"/>
    </template>
    <template  v-slot:[`item.cliente`]="{ item }">
        <v-edit-dialog
          :persistent="true"
          :return-value.sync="item.cliente"
          @save="dialogSave(item)"
        >
          {{ item.cliente }}
          <template v-slot:input>
            <div class="text-h6">Modifica il codice fiscale</div>
            <div class="text-caption">Usa Enter per confermare oppure Esc per annullare</div>
            <v-text-field
              v-model="item.cliente"
              :rules="[rules.codicefiscale]"
              label="Edit"
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>    
    <template v-slot:[`item.data`]="{ item }">
      {{ item.data && item.data.substring(0, 22) | date }}
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon small class="ml-3" title="Modifica richiesta sulla spesa" :color="iconaModificaTS(item).color">{{ iconaModificaTS(item).icon }}</v-icon>
      <v-menu :offset-x="true" left>
        <template v-slot:activator="{ on, attrs }">
          <v-icon small class="ml-3" @click="changeItem(item)" v-bind="attrs" v-on="on" title="Documento inviato al sistema TS">{{ iconaInvioTS(item) }}</v-icon>
        </template>
        <v-list two-line>
          <v-list-item link @click="menuClick(item, 'variazione')">
            <v-list-item-icon><v-icon color="green">mdi-send-variant-outline</v-icon></v-list-item-icon>              
            <v-list-item-content>
              <v-list-item-title>Variazione</v-list-item-title>
              <v-list-item-subtitle>Invia la variazione della riga di scontrino</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link @click="menuClick(item, 'rimborso')">
            <v-list-item-icon><v-icon color="orange">mdi-currency-usd-off</v-icon></v-list-item-icon>              
            <v-list-item-content>
              <v-list-item-title>Rimborso</v-list-item-title>
              <v-list-item-subtitle>Invia il rimborso della riga di scontrino</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link @click="menuClick(item, 'cancellazione')">
            <v-list-item-icon><v-icon color="red">mdi-delete-outline</v-icon></v-list-item-icon>              
            <v-list-item-content>
              <v-list-item-title>Cancellazione</v-list-item-title>
              <v-list-item-subtitle>Invia la cancellazione della riga di scontrino</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>      
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="getDataFromApi">Ricarica</v-btn>
    </template>
    </v-data-table>
    <speed-dial @comando="onSpeedDialogComando"/>
  </div>
</template>

<script>
  import moment from 'moment'
  import { verificaLicenza } from '@/mixins/verificaLicenza.js'
  import { validazioni } from '@/mixins/validazioni.js'
  import { dynamicSortMultiple } from '@/components/helpers.js'
  import DialogConferma from '@/components/dialogConferma'
  import DialogErrore from '@/components/dialogErrore'
  import SpeedDial from './components/speedDialDettaglio.vue'
  import Filtri from './components/filtri'
  import RispostaInvio from './components/rispostaInvio.vue'
  import scontrini from '@/services/scontriniService.js'
  import configurazioni from '@/services/configurazioniService.js'
  import ottici from '@/services/custom/otticiService.js'
  import _ from 'lodash'
  // const unzipper = require('unzipper')

  export default {
    components: {
      DialogConferma,
      DialogErrore,
      Filtri,
      SpeedDial,
      RispostaInvio
      // StampaEtichette
    },
    props: {
      // chiaveScontrino : Object
    },
    mixins: [verificaLicenza, validazioni],
    data (vm) {
      return {
        totaleScontrini: 0,
        scontrini: [],
        selected: [],
        loading: true,
        options: {},
        headers: [
          { text: 'Scontrino', value: 'documento', align: 'start'},
          { text: 'Data', value: 'data' },
          { text: 'Cliente', value: 'cliente' },
          { text: 'Prodotto', value: 'prodotto' },
          { text: 'T.S.', value: 'ts' },
          { text: 'Quantità', value: 'quantita' },
          { text: 'Prezzo', value: 'prezzo' },
          { text: 'Valore', value: 'valore' },
          { text: 'Sconto', value: 'sconto' },
          { text: 'Valore Detr.', value: 'valoreDetraibile' },
          { text: 'Actions', value: 'actions', sortable: false }
/*           { text: '', value: 'data-table-expand' } */
        ],
        expanded: [],
        singleExpand: false,
        dialogErrore: false,
        dialogConferma: false,
        titoloConferma: '',
        messaggioConferma: '',
        onConferma: vm.simula,
        simulazione: false,
        editedIndex: -1,
        editedItem: null,
        ssnn: null,
        filtri: null,
        tab: null,
        pathEtichettePrefix: '',
        // impostazioniEtichette: null,
        usaQtaAnagrafica: false, // TODO: da configurazioni
        salta: 0,
        filtroElementi: null,
        tipoStampa: '',
        report: '',
        erroreScontrino: '',
        esitoTrasmissione: null,
        dettaglioErrori: null,
        esitoInvio: null,
        ricevutaPdf: null,
        parametriXml: null,
        protocollo: null,
        showPanelXml: -1,
        xmlErrors: []
        // isModuloA4: false
      }
    },
    computed: {
      scontriniSaved() {
        return this.$store.getters['scontrini/saved']
      },
      refreshList() { // Verificare
        return this.$store.getters['scontrini/refreshDettaglio']
      },
      scontriniSorted() {
        const els = this.scontrini
        const elSorted = els.sort(dynamicSortMultiple('documento'))
        return elSorted
      },
      dettaglioAperto() {
        return this.$store.getters['scontrini/page'] === 'dettaglio'
      },
      generaDisabled() {
        return !this.filtri || (!this.filtri.soloNonTrasferiti && !this.filtri.soloInErrore) || this.totaleScontrini === 0 || this.loading
      },
      generazioneVisibile() {
        return _.get(this, 'ssnn.impostazioni.visualizzaGenerazione', true)
      },
      simulazioneVisibile() {
        return _.get(this, 'ssnn.impostazioni.visualizzaSimulazione', false)
      },
      invioVisibile() {
        return _.get(this, 'ssnn.impostazioni.visualizzaInvio', true)
      }
    },
    watch: {
      options: {
        async handler () {
          console.log('handler')
          await this.getDataFromApi()
        },
        deep: true
      },
      dialogConferma (val) {
        val || this.closeCreazione()
      },
      async scontriniSaved(value) {
        if (value && this.dettaglioAperto) {
          await this.save()
        }
      },
      async refreshList(value) {
        if (value) {
          // console.log('refreshList')
          await this.getDataFromApi()
          this.$store.commit('scontrini/CLEAR_REFRESH', 'dettaglio')
        }
      }
    },
    async mounted () {
      await this.verificaModuliLocali()
      this.ssnn = await configurazioni.getConfigurazione('ssnn')
    },
    methods: {
      iconaInvioTS(item) {
        return item && item && item.invioTS && item.invioTS.some(i => i.inviato && i.esito === 'ok') ? 'mdi-send-lock-outline' : ''
      },
      iconaModificaTS(item) {
        const flagOperazione = item.flagOperazione || (item.ssnn && item.ssnn.flagOperazione)
        switch (flagOperazione) {
          case 'V':
            return { icon: 'mdi-send-variant-outline', color: 'green' }
          case 'R':
            return { icon: 'mdi-currency-usd-off', color: 'orange' }
          case 'C':
            return { icon: 'mdi-delete-outline', color: 'red' }
          default:
            return { icon: '', color: '' }
        }
      },
      async onRicerca(filtri) {
        this.filtri = filtri
        console.log('onRicerca', this.filtri)
        await this.getDataFromApi()
      },
      async menuClick(item, tipoMenu) {
        switch (tipoMenu) {
          case 'variazione':
            item.flagOperazione = 'V'
            break
          case 'rimborso':
            item.flagOperazione = 'R'
            break
          case 'cancellazione':
            item.flagOperazione = 'C'
            break
          default:
            break
        }
        let scontrino = await scontrini.getScontrinoById(item._id)
        if (scontrino) {
          let riga = scontrino.righe.find(x => x.rigaCodice === item.rigaCodice)
          if (riga) {
            riga.ssnn.flagOperazione = item.flagOperazione
            await scontrini.updateScontrino(item._id, scontrino)
          }
        }
        this.$forceUpdate()
      },
      async getDataFromApi () {
        if (!this.filtri) return
        try {
          this.loading = true
          // this.parametriDetraibilita = this.parametriDetraibilita || await configurazioni.getConfigurazione('ssnn', 'parametriDefault')
          this.ssnn = this.ssnn || await configurazioni.getConfigurazione('ssnn')

          const parametri = {
            default: this.ssnn.parametriDefault,
            opzioni: this.options
          }
          const data = await scontrini.elencoScontriniDetraibili(this.filtri, parametri)
          this.scontrini = data.rows
          this.totaleScontrini = data.total_rows
        } catch(err) {
          this.scontrini = []
          this.totaleScontrini = 0
        } finally {
          this.loading = false
        }
      },
      onSimulaGenerazione() {
        this.titoloConferma = "Confermi simulazione file Xml ?"
        this.messaggioConferma = 'La procedura permette di simulare la generazione del file XML' +
          '<br/>Per sicurezza, i codici fiscali vengono sostituiti con * in modo che il file non sia trasferito per errore'
          '<br/><br/>Gli scontrini non vengono marcati come inviati e dovranno essere selezionati per l\'invio definitivo'
        
        this.onConferma = this.simula
        this.dialogConferma = true
        this.xmlErrors = []
      },
      onGeneraXML() {
        this.titoloConferma = "Confermi generazione file Xml ?"
        this.messaggioConferma = 'Viene generato un file xml con tutti i prodotti detraibili presenti negli scontrini del periodo ' +
           'che non sono ancora stati inviati al sistema TS. <br/><br/>' +
           'Gli scontrini vengono marcati come inviati e non potranno più essere selezionati'

        this.onConferma = this.genera
        this.dialogConferma = true
        this.xmlErrors = []
      },
      onInviaGenerazione() {
        this.titoloConferma = "Confermi invio a sistema TS ?"
        this.messaggioConferma = 'La procedura permette la generazione e l\'invio del file XML <br/>al sistema TS' +
          '<br/><br/>Gli scontrini vengono marcati come inviati e non sarranno più selezionati per invii successivi'
        this.onConferma = this.invia
        this.dialogConferma = true
        this.xmlErrors = []
      },
      onInviaSimulazione() {
        this.titoloConferma = "Confermi simulazione invio file Xml ?"
        this.messaggioConferma = 'La procedura permette di simulare la generazione e l\'invio del file XML' +
          '<br/><br/>Gli scontrini non vengono marcati come inviati e dovranno essere selezionati per l\'invio definitivo'
        this.onConferma = this.simulaInvio
        this.dialogConferma = true
        this.xmlErrors = []
      },
      async simula() {
        await this.generaXML(true)
      }, 
      async genera() {
        await this.generaXML(false)
      },
      async invia() {
        this.esitoTrasmissione = null
        this.dettaglioErrori = null
        this.esitoInvio = null
        this.ricevutaPdf = null
        await this.generaInviaXML(false)
      },
      async simulaInvio() {
        this.esitoTrasmissione = null
        this.dettaglioErrori = null
        this.esitoInvio = null
        this.ricevutaPdf = null
        await this.generaInviaXML(true)
      },   
      async generaXML(simulazione) {
        this.dialogConferma = false
        this.titoloConferma = ''
        this.messaggioConferma = ''
        try {
          this.loading = true
          this.ssnn = this.ssnn || await configurazioni.getConfigurazione('ssnn')
          // this.parametriDetraibilita = this.parametriDetraibilita || await configurazioni.getConfigurazione('ssnn', 'parametriDefault')
          const parametri = {
            default: this.ssnn.parametriDefault,
            optioni: this.options
          } // non passo le opzioni, rileggo tutti non paginati

          const data = await scontrini.elencoScontriniDetraibili(this.filtri, parametri)
          const documenti = data.rows

          const stampanti = await configurazioni.getConfigurazione('stampanti')
          let parametriXml = this.ssnn.parametriXml
          const st = []
          // TODO: Verificare come gestire ....
          for (let ct = 1; ct < 5; ct++) {
            if (stampanti[ct]) {
              st.push ({
                matricola: stampanti[ct].matricola_rt,
                dispositivo: stampanti[ct].progressivo_stampante
              })
            }
          }
          parametriXml.stampanti = [...st]
          parametriXml.simulazione = simulazione
          const xml = await ottici.generaXML(parametriXml, documenti)
          if (xml.status === 'error') {
            this.xmlErrors = xml.errori
            return
          }
          if (!simulazione) {
            await scontrini.registraInvioXML(documenti.map(x => { return { id: x._id, rigaCodice: x.rigaCodice, tipoInvio: 'I', esito: 'ok' }}))
          }
          const linkSource = 'data:text/plain;charset=utf-8,'  + encodeURIComponent(xml)
          const downloadLink = document.createElement("a")
          const fileName = `TS_${moment().format('YYYYMMDD')}.xml`

          downloadLink.href = linkSource
          downloadLink.download = fileName
          downloadLink.click()

        } catch(err) {
          console.log(err)
        } finally {
          this.loading = false
        }
      },
      async generaInviaXML(simulazione) {
        this.dialogConferma = false
        this.titoloConferma = ''
        this.messaggioConferma = ''
        try {
          this.loading = true
          this.ssnn = this.ssnn || await configurazioni.getConfigurazione('ssnn')
          // this.parametriDetraibilita = this.parametriDetraibilita || await configurazioni.getConfigurazione('ssnn', 'parametriDefault')
          const parametri = {
            default: this.ssnn.parametriDefault,
            optioni: this.options
          } // non passo le opzioni, rileggo tutti non paginati
          const data = await scontrini.elencoScontriniDetraibili(this.filtri, parametri)
          const documenti = data.rows

          const stampanti = await configurazioni.getConfigurazione('stampanti')
          let parametriXml = this.ssnn.parametriXml
          const st = []
          // TODO: Verificare come gestire ....
          for (let ct = 1; ct < 5; ct++) {
            if (stampanti[ct]) {
              st.push ({
                matricola: stampanti[ct].matricola_rt,
                dispositivo: stampanti[ct].progressivo_stampante
              })
            }
          }
          parametriXml.stampanti = [...st]
          parametriXml.simulazione = false // Se invio all'endpoit di test, i dati dei codifi fiscali devono essere corretti, altrimenti scarta il documento 
          if (this.filtri.soloInErrore) {
            // TODO: Verificare. Messo per rapidità. Andrebbe inserito nello scontrino ?
            parametriXml.flagOperazione = 'V'
          }
          const trasmissione = await ottici.generaInviaXML(parametriXml, documenti)
          if (trasmissione.status === 'error') {
            this.xmlErrors = trasmissione.errori
            return
          }          
          this.esitoTrasmissione = trasmissione
          this.parametriXml = parametriXml
          this.protocollo = trasmissione.protocollo
          this.showPanelXml = 0
          // TODO: Valori ed esiti dell'invio vanno salvati su database e ripresi successivamente per le verifiche
          // aggiungere un tab con i dati inviati
          if (!simulazione) {
            await scontrini.registraInvioXML(documenti.map(x => { return { id: x._id, rigaCodice: x.rigaCodice, tipoInvio: 'I', esito: 'ok' }}))
          }
        } catch(err) {
          console.log(err)
        } finally {
          this.loading = false
        }
      },
      async onEsitoInvio() {
        if (this.parametriXml && this.protocollo) {
          const esito = await ottici.esitoInvioXML(this.parametriXml, this.protocollo)
          this.esitoInvio = esito
        }
      },
      async onDettaglioErrori() {
        if (this.parametriXml && this.protocollo) {
          const dettaglio = await ottici.esitoErroriXML(this.parametriXml, this.protocollo)
          this.dettaglioErrori = dettaglio

          // File csv = this.dettaglio.esitiPositivi.dettagliEsito.csv
          console.log('dettaglio errori', dettaglio)
          const csv = dettaglio.esitiPositivi.dettagliEsito.csv
          console.log('csv', csv)
        // TODO: Sistemare. Il servizio ritorna il base64 del file ZIP contenente il CSV --> va salvato il file e poi riletto, decompresso ed utilizzato il contenuto
        /*   Unzipper non si installa con la versione corrente di Node --> verificare dopo aggiornato
          let buffer = Buffer.from(data, 'base64')
          const directory = await unzipper.Open.buffer(buffer)
          console.log('directory',directory)*/
          const righeCsv = csv.split('\n')
          
          if (righeCsv.length > 1) {
            await impostaErroriTrasmissione(righeCsv)
          }
        }   
      },
      async impostaErroriTrasmissione(righeCsv) {
        let errori = []
        for (let r of righeCsv.slice(1)) {
          const campi = r.split(';')
          const codiceFiscale = campi[0]
          const data = campi[5]
          const dispositivo = campi[6]
          const documento = campi[7]
          const tipoSpesa = campi[8]
          const codiceErrore = campi[9]

          // scrivere nello scontrino il tipo di errore
          // Se manca tipoSpesa --> errore relativo allo scontrino (es codice fiscale)
          // Altrimenti errore relativo alla riga
          errori.push({ codiceFiscale, dispositivo, data, documento, tipoSpesa, codiceErrore })
        }
        await scontrini.registraErroriInvioXML(errori)
      },
      async onRicevutaPdf() {
        if (this.parametriXml && this.protocollo) {
          const ricevutaPdf = await ottici.ricevutaPdfXML(this.parametriXml, this.protocollo)
          this.ricevutaPdf = ricevutaPdf
        }
      },
      // 
      async changeItem(item) {
        // usi futuri --> permette di riattivare l'invio della riga in caso di correzione o annullamento
        // Nel dettaglio della riga prevedere: info invio,  esito trasmissione, possibilità di reinviare, etc.
      },
      async createXmlConfirm () {
        this.closeCreazione()
        this.onGeneraXML()      
      },
      close () {
        this.$store.commit('SET_RIGHT_DRAWER', false)
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, null)
          this.editedIndex = -1
        })
      },
      closeCreazione () {
        this.dialogConferma = false
      },
      async dialogSave (item) {
        let scontrino = await scontrini.getScontrinoById(item._id)
        if (scontrino) {
          let riga = scontrino.righe.find(x => x.tipo === 'codicefiscale')
          if (riga) {
            riga.payload.codice = item.cliente.toUpperCase()
            riga.descrizione = `Codice fiscale: ${item.cliente.toUpperCase()}`
            await scontrini.updateScontrino(item._id, scontrino)
          }
          await this.menuClick(item, 'variazione')
        }
      }, 
      erroreConfirm() {
        this.dialogErrore = false
        this.erroreScontrino = ''
      },
      clickRow(item, options) {

      },
      dblclickRow(event, options) {
        const item = options.item
        this.editedIndex = this.scontrini.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.$store.commit('scontrini/SET_MOVIMENTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', true)
        this.$store.commit('SET_RIGHT_DRAWER', true)
      },
      datiVisualizzazione(scontrini) {
        const elaborati = scontrini.map(el => {
         // const nominativo = (el.anagrafica.fornitore && el.anagrafica.fornitore.descrizione) || (el.anagrafica.cliente && el.anagrafica.cliente.descrizione)
          const nominativo = (el.anagrafica.fornitore && el.anagrafica.fornitore.codice) || (el.anagrafica.cliente && el.anagrafica.cliente.codice)
          return { ...el, c_nominativo: nominativo }
        }) 
        return elaborati
      },
      deleteDatiVisualizzazione(scontrino) {
        let locScontrino = {...scontrino}
        delete locScontrino.c_nominativo
        delete locScontrino.appoggio
        return locScontrino
      },
      async onSpeedDialogComando(comando, payload) {
        switch (comando) {
/*           case 'stampa-etichette__':
            const impostazioni = await configurazioni.getConfigurazione('display_generale', 'etichette')
            this.tipoStampa = impostazioni.tipo
            this.report = impostazioni.report
            this.isModuloA4 = impostazioni.tipo === 'pdf'
            this.dialogStampa = true
            break */
          case 'stampa-etichette':
            this.$refs.stampaEtichette.stampaEtichette(this.elencoEtichette(), 'scontrini')
            this.annullaSelezione()
          default:
            break
        }
      },
	    elencoEtichette() {
        const etichette = this.selected.map(el => {
          return {
            id: el.scontrino.id,
            quantita: this.usaQtaAnagrafica ? 1 : el.quantita,
            idpr: el.prodotto.id
          }
        })
        return etichette
      },
 /*      onDialogCancel() {
        this.dialogStampa = false
      },
      async onDialogPrint(usaQtaAnagrafica, salta) {
        this.usaQtaAnagrafica = usaQtaAnagrafica
        this.salta = salta
        this.dialogStampa = false
        const etichette = this.selected.map(el => {
          return {
            id: el.scontrino.id,
            codice: el.prodotto.codice,
            descrizione: el.prodotto.descrizione,
            taglia: el.prodotto.variante1.codice,
            colore: el.prodotto.variante2.codice,
            prezzo: el.prodotto.prezzo,
            acquisto: el.prodotto.acquisto,
            barcode: el.prodotto.barcode,
            prezzo2: el.prodotto.prezzo2,
            quantita: this.usaQtaAnagrafica ? 1 : el.quantita
          }
        })
        await this.stampaEtichette(etichette)
      },
      async stampaEtichette(etichette) {
        try {
          // let selezionati = scontriniSelezionati
          const tipoQuantita = this.usaQtaAnagrafica ? 'anagrafica' : 'scontrino'
          // const impostazioni = await configurazioni.getConfigurazione('display_generale', 'etichette')
          // const str = JSON.stringify(etichette)

          await etichetteService.stampaEtichetta(this.tipoStampa, this.report, etichette, this.salta, tipoQuantita)
        } catch {
        }
        this.annullaSelezione()
      }, */
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      }
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }
    td.articoliSelected {
    border-style: solid!important;
    border-width: 2px!important;
    border-color: #1976d2 !important;
  }
</style>
